import React from 'react';
import ReactSVG from 'react-svg';
import { CircularProgress, DialogContent } from '@material-ui/core';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import * as lib from '~/dependencies';
import { SelectedIcon, NoSelectedIcon } from '~/assets/svgIcons';
import { findFlag } from '~/helpers/countryCodeAndFlagSelected';
import { BoxAccounts, ListAccounts } from './styles';
import { Dialog } from '../accounts/styles';

export default function CallerIds({
  outboundNumbers,
  userInfo,
  changeOutgoing,
  loading,
}) {
  // HOOKS
  const { t } = lib.useTranslation();

  const outboundNumbersList = Array.isArray(outboundNumbers?.numbers)
    ? outboundNumbers.numbers
    : [];

  const outboundAllowedNumbersList = userInfo?.isAdmin
    ? outboundNumbersList
    : outboundNumbersList.map(numberInfo => {
        if (numberInfo.selected) {
          if (
            userInfo?.user_permissions_access?.numbers?.includes(
              Number(numberInfo.number)
            )
          ) {
            return numberInfo;
          }

          return {
            ...numberInfo,
            name: undefined,
          };
        }

        return numberInfo;
      });

  const outboundNumbersInternational = outboundAllowedNumbersList?.map(e => {
    const phoneNumberItemInfo = parsePhoneNumberFromString(
      String(`+${e?.int_number}`)
    );

    const numberName =
      phoneNumberItemInfo?.number && e.name
        ? `${phoneNumberItemInfo.number} - ${e.name}`
        : phoneNumberItemInfo?.number;

    const countryCode = phoneNumberItemInfo?.countryCallingCode || null;

    const countryName = phoneNumberItemInfo?.country || null;

    return {
      int_number: e.int_number,
      name: e.name,
      number: e.number,
      numberName,
      countryCode,
      countryName,
    };
  });

  return (
    <BoxAccounts>
      <h3>{t('screens.configuration.components.callerIds.title')}</h3>
      <Dialog open={loading} aria-labelledby="draggable-dialog-title">
        <DialogContent>
          <CircularProgress className="loading" />
        </DialogContent>
      </Dialog>
      <ListAccounts>
        {outboundNumbersInternational &&
          Object.values(outboundNumbersInternational).map(e => {
            const countryFlagPath = findFlag(
              e.countryName ? e.countryName : e.countryCode,
              !!e.countryName
            );

            return (
              <div
                className="row"
                role="presentation"
                key={e.number}
                onClick={() =>
                  e.number === userInfo?.outbound_cli
                    ? {}
                    : changeOutgoing(e.number)
                }>
                <div>
                  <span>
                    {e.number && (
                      <img
                        src={countryFlagPath}
                        alt="flag"
                        style={{ maxWidth: 12, marginRight: 5 }}
                      />
                    )}
                    {e.numberName}
                  </span>
                </div>
                {e.number === userInfo?.outbound_cli && !loading ? (
                  <ReactSVG src={SelectedIcon} className="icon" />
                ) : (
                  <ReactSVG src={NoSelectedIcon} className="icon" />
                )}
              </div>
            );
          })}
      </ListAccounts>
    </BoxAccounts>
  );
}

CallerIds.defaultProps = {
  outboundNumbers: [],
  userInfo: {},
  loading: false,
  changeOutgoing: () => {},
};

CallerIds.propTypes = {
  outboundNumbers: lib.PropTypes.instanceOf(Object),
  userInfo: lib.PropTypes.instanceOf(Object),
  loading: lib.PropTypes.bool,
  changeOutgoing: lib.PropTypes.func,
};
